class ProductOrdermade extends HTMLElement {
  constructor () {
    super();

    this.elConditions = this.querySelectorAll('[data-ordermade-condition]');
    this.elCartProperties = this.querySelectorAll('[data-ordermade-cart-property]');
    this.elChargeCartProperty = this.querySelector('[data-ordermade-charge-cart-property]');
    this.elPropertyFields = this.querySelectorAll(`[data-ordermade-property-field]`);
    this.exChargeOptionVariantIds = [];

    this.elOrdermadePrice = document.querySelector('[data-ordermade-price]');
    this.elOrdermadePoint = document.querySelector('[data-ordermade-point]');
    if (this.elOrdermadePrice) {
      this.initOrdermadePrice();
    }

    this.initCondition();
    this.setFieldChangeEvent();
    this.setActiveProperty();
    this.updateCartProperty();
  }

  initCondition() {
    Array.from(this.elConditions).forEach((elCondition) => {
      const conditionType = elCondition.dataset.ordermadeConditionType;
      const matchedAction = elCondition.dataset.ordermadeConditionMatchedAction;

      const elTargetItems = elCondition.querySelectorAll('[data-ordermade-condition-target-item]');

      let targetItems = [];
      for (let i = 0; i < elTargetItems.length; i++) {
        const elItem = elTargetItems[i];

        targetItems.push({
          'id': elItem.dataset.ordermadeConditionTargetId,
          'name': elItem.dataset.ordermadeConditionTargetName,
          'value': this.getTargetValue(elItem.dataset.ordermadeConditionTargetValue)
        })
      }

      const result = this.isConditionTrue(targetItems, conditionType);
      this.switchCondition(elCondition, matchedAction, result);

      this.setConditionEvent(elCondition, targetItems, matchedAction, conditionType);
    });
  }

  isConditionTrue (targetItems, conditionType) {
    const results = [];
    for (let i = 0; i < targetItems.length; i++) {
      const targetItem = targetItems[i];
      const elTargets = document.querySelectorAll(`[data-ordermade-property-field="${targetItem.name}"]`);
      if (!elTargets.length) continue;

      const inputType = elTargets[0].type; // 同じname属性が付与された要素は、同じinput typeと想定して最初の要素のtypeで判定
      switch(inputType) {
        case 'radio':
          for (let j = 0; j < elTargets.length; j++) {
            const elTarget = elTargets[j];
            if (elTarget.checked) {
              const result = elTarget.value === targetItem.value ? 1 : 0;
              results.push(result);
            }
          }
          break;
        case 'select-one':
          const targetSelect = elTargets[0];
          const result = targetSelect.value === targetItem.value ? 1 : 0;
          results.push(result);
          break;
        case 'text':
          console.log('textの場合の判定処理作成');
          break;
        default:
          console.error(`ERROR: inputType: ${inputType}`);
      }
    }

    let result = false;
    if (results.length > 0) {
      if (conditionType === 'and') {
        result = results.every((eachResult) => eachResult === 1);
      } else {
        result = results.some((eachResult) => eachResult === 1);
      }
    }

    return result;
  }

  setConditionEvent (elCondition, targetItems, matchedAction, conditionType) {
    for (let i = 0; i < targetItems.length; i++) {
      const targetItem = targetItems[i];
      const elTargets = document.querySelectorAll(`[data-ordermade-property-field="${targetItem.name}"]`);
      if (!elTargets.length) continue;

      for (let j = 0; j < elTargets.length; j++) {
        const elTarget = elTargets[j];
        elTarget.addEventListener('change', () => {
          const result = this.isConditionTrue(targetItems, conditionType);
          this.switchCondition(elCondition, matchedAction, result);
        });
      }
    }
  }

  switchCondition (elCondition, matchedAction, result) {
    switch(matchedAction) {
      case 'visible':
        if (result) {
          elCondition.classList.add('ordermade-is-active');
          elCondition.setAttribute('data-ordermade-status','enable');
        } else {
          elCondition.classList.remove('ordermade-is-active');
          elCondition.setAttribute('data-ordermade-status','disable');
        }
        break;
      default:
        console.error(`ERROR: matchedAction: ${matchedAction}`);
    }
  }

  getTargetValue(valueStr) {
    if (!valueStr) return;
    let value;
    const valueLowerStr = valueStr.toLowerCase();
    if (valueLowerStr === 'true' || valueLowerStr === 'false') {
      value = JSON.parse(valueLowerStr)
    } else {
      value = valueStr;
    }

    return value;
  }

  setFieldChangeEvent () {
    Array.from(this.elPropertyFields).forEach((elField) => {
      elField.addEventListener('change', () => {
        this.setActiveProperty();
        this.updateCartProperty();

        if (this.elOrdermadePrice) {
          this.setOptionPrice();
          this.renderOrdermadePrice();
        }
        if (this.elOrdermadePoint) {
          this.calculatePoint();
          this.renderOrdermadePoint();
        }
      })
    });
  }

  setActiveProperty () {
    this.elActiveProperties = [];
    this.elActiveNodes = document.querySelectorAll('[data-ordermade-status="enable"]');
    Array.from(this.elActiveNodes).forEach((elActiveNode) => {
      this.elActiveProperties.push(...elActiveNode.querySelectorAll('[data-ordermade-property]'));
    });
  }

  updateCartProperty () {
    this.deleteCartProperty();
    this.elChargeCartProperty.setAttribute('value', '');

    const chargeOptionVariantIds = [];
    for (let i = 0; i < this.elActiveProperties.length; i++) {
      const elProperty = this.elActiveProperties[i];
      const propertyName = elProperty.dataset.ordermadePropertyName;
      const elPropertyFields = elProperty.querySelectorAll('[data-ordermade-property-field]');
      const elCartProperty = elProperty.querySelector('[data-ordermade-cart-property]');

      if (!elPropertyFields.length || !elCartProperty) continue;

      const { value, variantId } = this.getSelectedData(elPropertyFields);
      if (value) {
        elCartProperty.setAttribute('name', propertyName);
        elCartProperty.setAttribute('value', value);
      }
      if (variantId) {
        chargeOptionVariantIds.push(variantId);
      }
    };

    if (this.exChargeOptionVariantIds.length) {
      chargeOptionVariantIds.push(...this.exChargeOptionVariantIds);
    }

    const chargeOptionVariantId = chargeOptionVariantIds.join();
    this.elChargeCartProperty.setAttribute('value', chargeOptionVariantId);
  }

  getSelectedData (elPropertyFields) {
    let value;
    let variantId;
    const fieldType = elPropertyFields[0].type;
    switch(fieldType) {
      case 'radio':
        for (let j = 0; j < elPropertyFields.length; j++) {
          const elRadio = elPropertyFields[j];
          if (elRadio.checked) {
            value = elRadio.value;
            variantId = elRadio.dataset.ordermadeVariantId;
          }
        }
        break;
      case 'select-one':
        const elSelect = elPropertyFields[0];
        const index = elSelect.selectedIndex;
        value = elSelect.options[index].value;
        variantId = elSelect.options[index].dataset.ordermadeVariantId;
        break;
      case 'text':
        const elText = elPropertyFields[0];
        value = elText.value;
        break;
      case 'textarea':
        const elTextarea = elPropertyFields[0];
        value = elTextarea.value;
        break;
      default:
        console.error(`ERROR: fieldType: ${fieldType}`);
    }

    return { value, variantId };
  }

  deleteCartProperty () {
    Array.from(this.elCartProperties).forEach((elCartProperty) => {
      elCartProperty.setAttribute('name', '');
      elCartProperty.setAttribute('value', '');
    });
  }

  initOrdermadePrice () {
    this.basePrice = Number(this.elOrdermadePrice.dataset.ordermadeBasePrice);
    this.elPriceValue = document.querySelector('[data-ordermade-price-value]');

    const elChargeOptions = document.querySelectorAll('[data-ordermade-charge-option]');
    this.optionPriceData = {};
    Array.from(elChargeOptions).forEach((elOption) => {
      const variantId = elOption.dataset.ordermadeVariantId;
      const optionPriceStr = elOption.dataset.ordermadeOptionPrice;
      this.optionPriceData[variantId] = Number(optionPriceStr);
    });

    this.setOptionPrice();
    // 現状、デフォルトで加算される外部オプションがなかったため、初期値は0で設定
    this.exOptionPrice = 0;
    this.renderOrdermadePrice();
    if (this.elOrdermadePoint) {
      this.calculatePoint();
      this.renderOrdermadePoint();
    }

    this.elDefaultOptions = document.querySelectorAll('[data-ordermade-default-option]');
    Array.from(this.elDefaultOptions).forEach((elOption) => {
      elOption.addEventListener('change', () => {
        this.setBasePrice();
        this.renderOrdermadePrice();
        if (this.elOrdermadePoint) {
          this.calculatePoint();
          this.renderOrdermadePoint();
        }
      });
    });
  }

  getSelectedOption() {
    let selectedOption = []

    // ひとまずradioのみ対応
    Array.from(this.elDefaultOptions).map((elDefaultOption) => {
      const elInputs = elDefaultOption.querySelectorAll('input');
      selectedOption.push(Array.from(elInputs).find((radio) => radio.checked).value);
    });

    return selectedOption;
  }

  setBasePrice () {
    const selectedOption = this.getSelectedOption();
    this.basePrice = Number(this.getCurrentBasePrice(selectedOption));
  }

  getCurrentBasePrice(selectedOption) {
    let price = "";
    // ordermadeProductData は product-ordermade.liquid にて定義
    const variants = ordermadeProductData.variants;
    for (let i = 0; i < variants.length; i++) {
      const variant = variants[i]
      const matched = variant.options.filter((option) => selectedOption.includes(option));
      if (matched.length === selectedOption.length) {
        price = variant.price;
        break;
      }
    }
    return price;
  }

  setOptionPrice() {
    this.optionPrice = 0;

    // 費用が発生するオプションがない場合なにもしない
    if (Object.keys(this.optionPriceData).length === 0) return;

    const chargeOptionVariantIds = [];
    Array.from(this.elPropertyFields).forEach((elField) => {
      const fieldType = elField.type;
      let variantId = "";
      switch (fieldType) {
        // ひとまずradioのみ対応
        case 'radio':
          if (elField.checked) {
            variantId = elField.dataset.ordermadeVariantId;
          }
          break;
        case 'select-one':
          const index = elField.selectedIndex;
          variantId = elField.options[index].dataset.ordermadeVariantId;
          break;
        default:
          // その他処理は請求とならない
      }
      if (variantId) {
        chargeOptionVariantIds.push(variantId);
      }
    });

    chargeOptionVariantIds.forEach((variantId) => {
      this.optionPrice += this.optionPriceData[variantId]
    });
  }

  calculatePoint() {
    // ポイント付与率を静的に記載しているため、ポイント付与率を変更する場合は注意
    const pointRate = 0.05;
    const basePriceWithoutTax = this.getPriceWithoutTax(this.basePrice);
    const optionPriceWithoutTax = this.getPriceWithoutTax(this.optionPrice);
    const exOptionPriceWithoutTax = this.getPriceWithoutTax(this.exOptionPrice);

    this.point = Math.round((basePriceWithoutTax + optionPriceWithoutTax + exOptionPriceWithoutTax) * pointRate);
  }

  renderOrdermadePrice () {
    const ordermadePrice = this.basePrice + this.optionPrice + this.exOptionPrice;
    this.elPriceValue.textContent = this.formatMoney(ordermadePrice);
  }

  renderOrdermadePoint () {
    this.elPointValue = this.elPointValue || this.elOrdermadePoint.querySelector('[data-ordermade-point-value]');
    this.elPointValue.textContent = this.formatDigit(this.point).toLocaleString();
  }

  formatMoney(price) {
    return this.formatDigit(price).toLocaleString();
  }

  formatDigit (price) {
    // Shopifyから返される価格は下2桁追加されている形のため調整
    return price / 100;
  }

  getPriceWithoutTax(price) {
    this.taxRate = this.taxRate || Number(this.elOrdermadePoint.dataset.taxRate);
    // 小数点以下の計算で端数が発生している場合があるためまるめた金額を返す
    return Math.round(price/(1 + this.taxRate));
  }

  // 外部の有料オプション取り込みで使用
  addExternalChargeOption ({variantId, price}) {
    // 既に選択したオプションが入っている場合は何もしない
    if (this.exChargeOptionVariantIds.includes(variantId)) return;

    this.exChargeOptionVariantIds.push(variantId);
    this.updateCartProperty();

    this.exOptionPrice = this.exOptionPrice + price;
    this.renderOrdermadePrice();

    if (this.elOrdermadePoint) {
      this.calculatePoint();
      this.renderOrdermadePoint();
    }
  }

  deleteExternalChargeOption ({variantId, price}) {
    // 選択したオプションが入っていない場合は何もしない
    if (!this.exChargeOptionVariantIds.includes(variantId)) return;

    this.exChargeOptionVariantIds = this.exChargeOptionVariantIds.filter((id) => id !== variantId);
    this.updateCartProperty();

    const newExOptionPrice = this.exOptionPrice - price;
    this.exOptionPrice = newExOptionPrice > 0? newExOptionPrice : 0;
    this.renderOrdermadePrice();

    if (this.elOrdermadePoint) {
      this.calculatePoint();
      this.renderOrdermadePoint();
    }
  }
}

customElements.define('product-ordermade', ProductOrdermade);
